export enum Answer {
  Yes = "yes",
  No = "no",
  DontKnow = "dontknow",
}
